<template>
     <h3 class="text-center my-4">
            <i class="bi bi-bar-chart-line-fill me-2 text-danger"></i>
            BRGY SUMMARY
          </h3>
    <div class="form-group">
        <select class="form-select" v-model="cityId" @change="getSummary">
            <option v-for="city in cities" :key="city.id_mun" :value="city.id_mun">{{ city.name_mun }}</option>
        </select>
    </div>
    <div>
        <div v-if="!isFetching">
        <!-- Mobile-specific table layout -->
        <div class="d-lg-none">
         

          <div
            v-for="brgy in brgys"
            :key="brgy.id_brgy"
            class="card mb-3 shadow-sm border-light"
            :class="{
              'bg-primary text-white': getLead(brgy.totalvoter, brgy.teamok) <= 0,
              'bg-danger text-white':
                getLead(brgy.totalvoter, brgy.teamok) > 0 && cityId !== 3,
              'bg-success text-white':
                getLead(brgy.totalvoter, brgy.teamok) > 0 && cityId === 3,
            }"
          >
            <div class="card-body">
              <!-- Card Header -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="card-title m-0">
                  {{ brgy.city_voter }} - {{ brgy.brgy_voter }}
                </h5>
                <span class="badge bg-light text-dark fw-bold px-3 py-2"
                  >Voters: {{ brgy.totalvoter }}</span
                >
              </div>
              <hr class="bg-light opacity-75" />

              <!-- Details -->
              <div class="mb-3">
                <p class="mb-1">
                  <strong><i class="bi bi-people-fill me-1"></i> TRV: </strong>
                  <span class="text-warning"> {{ brgy.totalrawvoter }}</span>
                </p>
                <p class="mb-1">
                  <strong><i class="bi bi-people-fill me-1"></i> Projected: </strong>
                  <span class="text-warning"> {{ brgy.totalvoter }}</span>
                </p>
                <p class="mb-1">
                  <strong><i class="bi bi-people-fill me-1"></i> Supporters: </strong>
                  <span class="text-warning"> {{ brgy.teamok }}</span>
                </p>
                <p class="mb-1">
                  <strong><i class="bi bi-graph-up-arrow me-1"></i> Undecided: </strong>
                  <span class="text-info"> {{ brgy.undecided }}</span>
                </p>
                <p class="mb-1">
                  <strong><i class="bi bi-graph-up-arrow me-1"></i> Out of Town: </strong>
                  <span class="text-info"> {{ brgy.outoftown }}</span>
                </p>
                <p class="mb-1">
                  <strong
                    ><i class="bi bi-graph-up-arrow me-1"></i>
                    {{ customizationService.getNonSupporterTerm(cityId) }}:
                  </strong>
                  <span class="text-info">
                    {{
                      brgy.totalvoter - brgy.teamok - brgy.undecided - brgy.outoftown
                    }}</span
                  >
                </p>
                <p class="mb-1">
                  <strong><i class="bi bi-graph-up-arrow me-1"></i> Lead: </strong>
                  <span class="text-info">
                    {{ getLead(brgy.totalvoter, brgy.teamok) }}</span
                  >
                </p>

                <p class="mb-1">
                  <strong><i class="bi bi-bar-chart me-1"></i> Break-even Point: </strong>
                  <span class="text-light">
                    {{ getBreakEvenPoint(brgy.totalvoter, brgy.teamok) }}</span
                  >
                </p>
              </div>

              
            </div>
          </div>
        </div>
      </div>
      <SpinnerBlock class="d-lg-none" v-else />
      <div class="table-responsive d-none d-lg-block" id="tablePrintDashboard">
        <table class="table align-middle">
          <thead>
            <tr>
              <th style="min-width: 120px">City</th>
              <th class="brgy">Brgy</th>
              <th>
                <ToolTip :text="'Original Number of Voters from Comelec TRV'">
                  TRV
                </ToolTip>
              </th>
              <th>
                <ToolTip
                  :text="'Total expected voters, based on previous election results turn-out percentage.'"
                >
                  Projected
                </ToolTip>
              </th>
              <th v-if="cityId === 1001">
                <ToolTip :text="'Projected * Percentage Target'"> Target </ToolTip>
              </th>
              <th>
                <ToolTip :text="'Total Confirmed Supporters'"> Supporters </ToolTip>
              </th>
              <th v-if="cityId === 1">
                <ToolTip :text="'Total Supporters With OK Status'"> OK </ToolTip>
              </th>
              <th>
                <ToolTip :text="'Paling-paling'"> Undecided </ToolTip>
              </th>
              <th>
                <ToolTip :text="'Out of town or country'"> OutOfTown </ToolTip>
              </th>
              <th>
                <ToolTip :text="'Prjoected Non Supporters'">
                  {{ customizationService.getNonSupporterTerm(cityId) }}
                </ToolTip>
              </th>
              <th>
                <ToolTip
                  :text="'Deceased'"
                >
                </ToolTip>
                Deceased
              </th>
              <th>
                <ToolTip
                  :text="'Religious Group'"
                >
                </ToolTip>
                Religious Group
              </th>
              <th>
                <ToolTip
                  :text="'Null Supporters'"
                >
                </ToolTip>
                Null Supporters
              </th>
              <th>
                <ToolTip
                  :text="'Null Non-Supporters'"
                >
                </ToolTip>
                Null Non-Supporters
              </th>
              <th>
                <ToolTip
                  :text="'Computed Lead or Deficit based on supporter vs non-supporter data.'"
                >
                  Lead
                </ToolTip>
              </th>
              <th>
                <ToolTip
                  :text="'Break-even points: The number of people we need to convert as supporters in order to level the playing field.'"
                >
                  BP
                </ToolTip>
              </th>
              <th>
                <ToolTip :text="`${customizationService.getPLeaderLabel(cityId)}S`">
                  {{ customizationService.getPLeaderLabel(cityId) }}
                </ToolTip>
              </th>
              <th>
                <ToolTip :text="`${customizationService.getLeaderLabel(cityId)}S`">
                  {{ customizationService.getLeaderLabel(cityId) }}
                </ToolTip>
              </th>
              <th>
                <ToolTip :text="`${customizationService.getSubLeaderLabel(cityId)}S`">
                  {{ customizationService.getSubLeaderLabel(cityId) }}
                </ToolTip>
              </th>
              <th>
                <ToolTip :text="'MEMBERS'"> Members </ToolTip>
              </th>
              <th>
                <ToolTip :text="'DONE VOTING'"> Completed </ToolTip>
              </th>
              <th>
                <ToolTip :text="'At the precinct'"> Partial </ToolTip>
              </th>
              <th>
                <ToolTip :text="'Watiting to show up'"> Pending </ToolTip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isFetching">
              <td class="text-center" colspan="12">
                <SpinnerBlock />
              </td>
            </tr>
            <tr
              class="text-start"
              v-for="brgy in brgys"
              :key="brgy.id_brgy"
            >
              <td>
                {{ brgy.city_voter }}
              </td>
              <td class="text-start">{{ brgy.brgy_voter }} {{ brgy.cityid_brgy }}</td>
              <td class="text-center">{{ brgy.totalrawvoter }}</td>
              <td class="text-center">{{ brgy.totalvoter }}</td>
              <td v-if="cityId === 1001" class="text-center">
                {{ brgy.totaltargetvoter }}
              </td>
              <td class="text-center">{{ brgy.teamok }}</td>
              <td v-if="cityId === 1" class="text-center">{{ brgy.ok }}</td>
              <td class="text-center">{{ brgy.undecided }}</td>
              <td class="text-center">{{ brgy.outoftown }}</td>
              <td class="text-center">
                {{ brgy.totalvoter - brgy.teamok - brgy.undecided - brgy.outoftown }}
              </td>
              <td class="text-center">{{ brgy.deceased }}</td>
              <td class="text-center">{{ brgy.religious }}</td>
              <td class="text-center">{{ brgy.blanksup }}</td>
              <td class="text-center">{{ brgy.blanknonsup }}</td>
              <td class="text-center">{{ getLead(brgy.totalvoter, brgy.teamok) }}</td>
              <td class="text-center">
                {{ getBreakEvenPoint(brgy.totalvoter, brgy.teamok) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'pleaders',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.city_voter
                    )
                  "
                  >{{ brgy.pleaders }}</a
                >
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'leaders',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                  >{{ brgy.leaders }}</a
                >
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'subleaders',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                >
                  {{ brgy.subleaders }}</a
                >
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'members',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                  >{{ brgy.members }}</a
                >
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'completed',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                >
                  {{ brgy.completed }}
                </a>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'partial',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                  >{{ brgy.partial }}</a
                >
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-decoration-none text-secondary fw-bold"
                  @click.prevent="
                    handleClickAction(
                      brgy.brgyid_voter,
                      'pending',
                      brgy.city_voter,
                      brgy.brgy_voter,
                      brgy.cityid_voter
                    )
                  "
                  >{{ brgy.pending }}</a
                >
              </td>
            </tr>
            <tr v-if="brgys !== null && brgys.length > 0">
              <td class="text-center fw-bold" colspan="2">TOTALS</td>
              <td class="text-center">{{ totalRawVoters }}</td>
              <td class="text-center">{{ totalProjectedVoters }}</td>
              <td v-if="cityId === 1001" class="text-center">
                {{ totalTargetedVoters }}
              </td>
              <td class="text-center">{{ totalSupporters }}</td>
              <td v-if="cityId === 1" class="text-center">{{ totalOk }}</td>
              <td class="text-center">{{ totalUndecided }}</td>
              <td class="text-center">{{ totalOutOfTown }}</td>
              <td class="text-center">{{ totalNonSupporters }}</td>
              <td class="text-center">{{ getTotalLeads }}</td>
              <td class="text-center">{{ getTotalBreakEvenPoint }}</td>
              <td class="text-center">{{ getTotalPLeaders }}</td>
              <td class="text-center">{{ getTotalLeaders }}</td>
              <td class="text-center">{{ getTotalSubLeaders }}</td>
              <td class="text-center">{{ getTotalMembers }}</td>
              <td class="text-center">{{ getTotalCompleted }}</td>
              <td class="text-center">{{ getTotalPartial }}</td>
              <td class="text-center">{{ getTotalPending }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>
<script setup>
import SpinnerBlock from '@/components/animations/SpinnerBlock.vue';
import areaService from '@/services/areaService';
import customizationService from '@/services/customizationService';
import reportService from '@/services/reportService';

import { onMounted, ref } from 'vue';
const isFetching = ref(false);
const cities = ref([]);
const cityId = ref(0);
const brgys = ref([]);
const getCities = async()=>{
    cities.value = await areaService.getMunicipalities();
    if(cities.value.length > 0){
        cityId.value = cities.value[0].id_mun;
    }
    getSummary();
}
const getBreakEvenPoint = (total, sup) => {
      const nonsupporters = total - sup;
      return Math.ceil((nonsupporters - sup) / 2);
    };

//eslint-disable-next-line
const getSummary = async ()=>{
    isFetching.value = true;
    brgys.value = await reportService.getBrgySummary(cityId.value);
    isFetching.value = false;
}
//eslint-disable-next-line
const getLead = (total, supporters) => {
      const nonSupporters = total - supporters;
      // Calculate the difference between supporters and non-supporters
      const lead = Number(supporters) - Number(nonSupporters);
      return lead;
    };

onMounted(()=>{
    getCities();
})
</script>